export default __webpack_public_path__ + "30f48352ab6556ed0642e671bc3b67c0.jpeg";